enum COURSE_INSTANCE_ACTIONS {
  FETCH_COURSE_INSTANCE = 'FETCH_COURSE_INSTANCE',
  FETCH_COURSE_DETAILS = 'FETCH_COURSE_DETAILS',
  FETCH_MODULES_LEARNING_RESULTS = 'FETCH_MODULES_LEARNING_RESULTS',
  FETCH_INSTANCE_ACCESS_FOR_STUDENTS = 'FETCH_INSTANCE_ACCESS_FOR_STUDENTS',
  FETCH_INSTANCE_ACCESS_FOR_LECTURERS = 'FETCH_INSTANCE_ACCESS_FOR_LECTURERS',
  FETCH_LECTURER_ACCESS_FOR_MODULE = 'FETCH_LECTURER_ACCESS_FOR_MODULE',
  FETCH_STUDENTS_EXERCISES_RESULT = 'FETCH_STUDENTS_EXERCISES_RESULT',
  FETCH_STUDENTS_EXERCISES_RESULT_START = 'FETCH_STUDENTS_EXERCISES_RESULT_START',
  FETCH_STUDENTS_EXERCISES_RESULT_FINISH = 'FETCH_STUDENTS_EXERCISES_RESULT_FINISH',
  SET_POINTS_FOR_EXERCISE_START = 'SET_POINTS_FOR_EXERCISE_START',
  SET_POINTS_FOR_EXERCISE_FINISH = 'SET_POINTS_FOR_EXERCISE_FINISH',
  SET_POINTS_FOR_CRITERIA_START = 'SET_POINTS_FOR_CRITERIA_START',
  SET_POINTS_FOR_CRITERIA_FINISH = 'SET_POINTS_FOR_CRITERIA_FINISH',
  FETCH_COURSE_CRITERIA_GROUP = 'FETCH_COURSE_CRITERIA_GROUP',
  SET_PUBLICATION_START = 'SET_PUBLICATION_START',
  SET_PUBLICATION_FINISH = 'SET_PUBLICATION_FINISH',
  SET_POINTS_FOR_STUDENT_START = 'SET_POINTS_FOR_STUDENT_START',
  SET_POINTS_FOR_STUDENT_FINISH = 'SET_POINTS_FOR_STUDENT_FINISH',
}

export default COURSE_INSTANCE_ACTIONS;
